import Route from 'rise-ui/utils/routing/route.js';

import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class CatalogRoute extends Route {
  @breadcrumb crumb = 'Catalog';
}
